import styled from "styled-components";
import Link from "next/link";
import { RATypography } from "@/components/customs";
import { Col, Grid, Row } from "antd";
import { useTrackVisibility } from "react-intersection-observer-hook";
import { PATH_ROUTES } from "@/config/routes";

const { useBreakpoint } = Grid;

export function FAQSContactUs({ contact_us = {} }) {
	const screens = useBreakpoint();
	const [ref] = useTrackVisibility();
	return (
		<HomeContactContainer ref={ref}>
			<WrapperContent>
				<RATypography variant={screens?.md ? "h2" : "h4"} color="#fff" style={{ textAlign: "center" }}>
					{contact_us?.title || ""}
				</RATypography>
				<Row justify="center">
					<Col span={24}>
						<WrapperCardItem>
							<RATypography variant="body3" color="#fff" style={{ opacity: 0.7 }} align="center">
								{contact_us?.sub_title || ""}
							</RATypography>
						</WrapperCardItem>
					</Col>
					<Col span={24}>
						<WrapperCardItem>
							<Link href={PATH_ROUTES.PATH_CONTACT_US}>
								<ContactButton>
									<TextContactUs>{contact_us?.button_content || ""}</TextContactUs>
								</ContactButton>
							</Link>
						</WrapperCardItem>
					</Col>
				</Row>
			</WrapperContent>
		</HomeContactContainer>
	);
}

const WrapperCardItem = styled.div`
	padding: 12px;
	display: flex;
	justify-content: center;
	align-items: center;
`;
const HomeContactContainer = styled.div`
	width: 100%;
	position: relative;
	border-radius: 12px;
	background-image: url("/images/layout/mask_layout.png");
	background-size: cover;
	background-position: center center;
	background-color: rgba(0, 0, 0, 0.8);
	@media (max-width: 576px) {
		background-image: url("/images/layout/mask_layout_mobile.png");
	}
	margin-bottom: 60px;
`;
const WrapperContent = styled.div`
	display: flex;
	justify-content: center;
	flex-direction: column;
	align-items: center;
	padding: clamp(16px, 4vw, 64px);
`;
const ContactButton = styled.button`
	border-radius: 40px;
	border: 0.5px solid #fff;
	display: flex;
	padding: 12px 30px;
	align-items: center;
	gap: 12px;
	background: transparent;
	cursor: pointer;
`;
const TextContactUs = styled.div`
	color: #fff;
	font-feature-settings:
		"clig" off,
		"liga" off;
	font-family: "DM Sans";
	font-size: 16px;
	font-style: normal;
	font-weight: 400;
	line-height: 24px; /* 150% */
	letter-spacing: 2px;
`;
